var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-12" }, [
        _c("small", { staticClass: "font-weight-bold" }, [
          _vm._v(
            _vm._s(_vm.data.type == "D" ? "DEFECTO" : "CASO " + _vm.id) + ": "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.data.values, function (item, index) {
        return _c("div", { key: index, staticClass: "col-lg-6 px-0" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-10 px-0" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-4 px-1 mb-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.min,
                        expression: "item.min",
                      },
                    ],
                    ref: "values" + index + "min",
                    refInFor: true,
                    staticClass: "form-control form-control-sm",
                    domProps: { value: item.min },
                    on: {
                      keypress: _vm.DOUBLE,
                      focus: function ($event) {
                        return _vm.SET_INPUT("values." + index + ".min")
                      },
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(item, "min", $event.target.value)
                        },
                        _vm.GET_INPUT,
                      ],
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 px-1 mb-2" },
                  [
                    _c("v-select", {
                      staticClass: "form-control form-control-sm",
                      attrs: { items: _vm.operators, "hide-details": "" },
                      model: {
                        value: item.operator,
                        callback: function ($$v) {
                          _vm.$set(item, "operator", $$v)
                        },
                        expression: "item.operator",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-4 px-1 mb-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.max,
                        expression: "item.max",
                      },
                    ],
                    ref: "values" + index + "max",
                    refInFor: true,
                    staticClass: "form-control form-control-sm",
                    attrs: { type: "text" },
                    domProps: { value: item.max },
                    on: {
                      keypress: _vm.DOUBLE,
                      focus: function ($event) {
                        return _vm.SET_INPUT("values." + index + ".max")
                      },
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(item, "max", $event.target.value)
                        },
                        _vm.GET_INPUT,
                      ],
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-2 px-lg-0 px-1 mb-2" },
              [
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  attrs: {
                    items: _vm.conditions,
                    disabled: item.disabled,
                    "hide-details": "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.ADD_REMOVE_ITEM(index)
                    },
                  },
                  model: {
                    value: item.condition,
                    callback: function ($$v) {
                      _vm.$set(item, "condition", $$v)
                    },
                    expression: "item.condition",
                  },
                }),
              ],
              1
            ),
          ]),
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 mb-3" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-1 px-1 mb-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.data.return.min,
              expression: "data.return.min",
            },
          ],
          ref: "returnmin",
          staticClass: "form-control form-control-sm",
          domProps: { value: _vm.data.return.min },
          on: {
            focus: function ($event) {
              return _vm.SET_INPUT("return.min")
            },
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data.return, "min", $event.target.value)
              },
              _vm.GET_INPUT,
            ],
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-1 px-1 mb-2" },
        [
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            attrs: { items: _vm.mats, "hide-details": "" },
            model: {
              value: _vm.data.return.mat,
              callback: function ($$v) {
                _vm.$set(_vm.data.return, "mat", $$v)
              },
              expression: "data.return.mat",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-1 px-1 mb-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.data.return.max,
              expression: "data.return.max",
            },
          ],
          ref: "returnmax",
          staticClass: "form-control form-control-sm",
          attrs: { type: "text" },
          domProps: { value: _vm.data.return.max },
          on: {
            focus: function ($event) {
              return _vm.SET_INPUT("return.max")
            },
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data.return, "max", $event.target.value)
              },
              _vm.GET_INPUT,
            ],
            keypress: _vm.DOUBLE_OPERATOR,
          },
        }),
      ]),
      _vm._v(" "),
      _vm.data.type != "D"
        ? _c("div", { staticClass: "col-lg-1" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-h btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.REMOVE(_vm.data.id)
                  },
                },
              },
              [_vm._m(1)]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-1" }, [
      _c("small", { staticClass: "font-weight-bold" }, [_vm._v("RETORNA ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "bi bi-x" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }